import React from 'react';
import CabinetShell from '../../components/UI/CabinetShell/cabinetShell';
import "./settings.css"
import SettingsNav from '../../components/UI/SettingsNav/settingsNav';
import RandomNumberGenerator from '../../components/UI/RandomNumberGenerator/RandomNumberGenerator';
import { useTheme } from '../../hooks/useTheme';
const GenerateCode = () => {
  const [activeLink, setActiveLink] = React.useState(null);
  const { theme, setTheme } = useTheme()
  React.useEffect(() => {
    setActiveLink(`${(window.location.pathname).substring((window.location.pathname).lastIndexOf('/')+1)}`);
  })
 


    return (
        <CabinetShell title="Код регистрации" floor={false}>
            <SettingsNav activeLink={activeLink} setActiveLink={setActiveLink}/>

            <div className='settingsContent'>
                <div>
                    <RandomNumberGenerator/>
                </div>
            </div>

        </CabinetShell>
    );
};


export default GenerateCode;

